/*
 * @Author: Jon Lucas
 * @Date: 2017-10-18 15:42:43
 * @Last Modified by: Jon Lucas
 * @Last Modified time: 2017-10-18 17:01:18
 */


import {Component, ViewChild} from "@angular/core";

import {AbstractViewComponent} from "../abstract-view/abstract-view.component";

import {BaseDataType} from "../../base-data-type";

import {ConfDataType} from "../../conf-data-type";
import {AppService} from "../../app.service";
import {ActivatedRoute} from "@angular/router";
import {FormGroup, NgForm, FormControl} from "@angular/forms";
import {LabelType} from "../../label-type";
import {Utils} from "../../util/Utils";

@Component({
    selector: "app-roof-dimensions",
    templateUrl: "./roof-dimensions.component.html",
    styleUrls: ["./roof-dimensions.component.scss"]
})
export class RoofDimensionsComponent extends AbstractViewComponent {

    public static readonly TAG: string = "[RoofDimensionComponent]";

    public dimensionsType: BaseDataType;

    @ViewChild("roofingDimensionsForm") roofingDimensionsForm;

    private roofDimForm: FormGroup;
    protected selectedFacadeOption: string;
    protected belrivTradiSelected: boolean;
    protected roofType: string;

    /**
     * Main form data dictionary.
     */
    public valuesDictionary: { [key: string]: number };
    public errorsDictionary: { [key: string]: string };

    protected inputFieldMessages: { [key: string]: LabelType };

    private requiredFields: string[];

    constructor(protected route: ActivatedRoute) {
        super(route);
    }

    /**
     * Values are saved in confDataService.
     *
     * @param pId {string}
     */
    onKey(pId: string): void {
        console.log(RoofDimensionsComponent.TAG, pId);

        // Get belrivTradiSelected si chevrons
        if(pId == "chevrons") {
            this.belrivTradiSelected = (this.confDataService.getElementOptions("project-type") && this.confDataService.getElementOptions("project-type").indexOf("belriv-tradi") != -1);
        }

        // Reset error
        delete this.errorsDictionary[pId];

        // Check min max
        switch (pId) {
            case"cote-a": {
                this.checkMinMax(pId, 0.1, "min-01", 99, "max-99");
                break;
            }
            case "cote-b" : {
                this.checkMinMax(pId, 0.1, "min-01", 99, "max-99");
                break;
            }
            case "cote-c" : {
                this.checkMinMax(pId, 0.1, "min-01", 99, "max-99");
                break;
            }
            case "cote-d" : {
                this.checkMinMax(pId, 0.1, "min-01", 99, "max-99");
                break;
            }
            case "cote-e" : {
                this.checkMinMax(pId, 0.1, "min-01", 99, "max-99");
                break;
            }
            case "cote-f" : {
                this.checkMinMax(pId, 0.1, "min-01", 99, "max-99");
                break;
            }
            case "cote-g" : {
                this.checkMinMax(pId, 0.1, "min-01", 99, "max-99");
                break;
            }
            case "angle-x" : {
                this.checkMinMax(pId, 91, "min-91", 179, "max-179");
                break;
            }
            case "chevrons" : {
                if (this.belrivTradiSelected || this.confDataService.getElementValues("project-type")[0] === "projet-goutiere") {
                    this.checkMinMax(pId, 0.3, "min-03", 0.6, "max-06");
                } else {
                    this.checkMinMax(pId, 0.3, "min-03", 0.9, "max-09");
                }

                break;
            }
            case "debord" : {
                this.checkMinMax(pId, 0.1, "min-01", 4, "max-4");
                break;
            }
            case "cote-l2" : {
                this.checkMinMax(pId, 0.1, "min-01", 4, "max-4");
                break;
            }
            case "hauteur": {
                break;
            }
            case "pente" : {
                this.checkMinMax(pId, 0, "min-0", 75, "max-75");
                break;
            }
            default:
                break;
        }



        this.confDataService.updateElementErrors("roof-dimensions", [this.errorsDictionary]);
        this.confDataService.updateElementValues("roof-dimensions", [this.valuesDictionary]);

        this.checkValid(this.roofingDimensionsForm);
    }

    private checkCoteConstraints(): void {

        let ruleName = "";

        this.roofType = this.confDataService.getElementValues("roof-type")[0];

        switch (this.roofType) {
            case "1-pan":
            case "2-pans":
            case "3-pans":
            case "4-pans": {
                /*
                // A > B
                ruleName = "b-inf-a";
                if (
                    this.valuesDictionary["cote-a"] !== undefined
                    && this.valuesDictionary["cote-b"] !== undefined
                ) {
                    console.log(RoofDimensionsComponent.TAG, "Checking rule " + ruleName + " ...");
                    const a = this.valuesDictionary["cote-a"];
                    const b = this.valuesDictionary["cote-b"];
                    if (a < b) {
                        this.errorsDictionary["cote-a"] = ruleName;
                    } else {
                        delete this.errorsDictionary["cote-a"];
                    }
                }
                */
                break;
            }
            /*case "2-pans-garage": {

                // A = C + D
                ruleName = "a-eq-c-plus-d";
                if (
                    this.valuesDictionary["cote-a"] !== undefined
                    && this.valuesDictionary["cote-c"] !== undefined
                    && this.valuesDictionary["cote-d"] !== undefined
                ) {
                    console.log(RoofDimensionsComponent.TAG, "Checking rule " + ruleName + " ...");
                    const a = this.valuesDictionary["cote-a"];
                    const c = this.valuesDictionary["cote-c"];
                    const d = this.valuesDictionary["cote-d"];
                    if (a !== (c + d)) {
                        this.errorsDictionary["cote-a"] = ruleName;
                    } else {
                        delete this.errorsDictionary["cote-a"];
                    }
                }

                break;

            }*/
            /*case "4-pans-l": {

                // B = E + D
                ruleName = "b-eq-e-plus-d";
                if (
                    this.valuesDictionary["cote-b"] !== undefined
                    && this.valuesDictionary["cote-d"] !== undefined
                    && this.valuesDictionary["cote-e"] !== undefined
                ) {
                    console.log(RoofDimensionsComponent.TAG, "Checking rule " + ruleName + " ...");
                    const b = this.valuesDictionary["cote-b"];
                    const d = this.valuesDictionary["cote-d"];
                    const e = this.valuesDictionary["cote-e"];
                    if (b !== (e + d)) {
                        this.errorsDictionary["cote-b"] = ruleName;
                    } else {
                        delete this.errorsDictionary["cote-b"];
                    }
                }

                // C = A - E
                ruleName = "c-eq-a-minus-e";
                if (
                    this.valuesDictionary["cote-c"] !== undefined
                    && this.valuesDictionary["cote-a"] !== undefined
                    && this.valuesDictionary["cote-e"] !== undefined
                ) {
                    console.log(RoofDimensionsComponent.TAG, "Checking rule " + ruleName + " ...");
                    const c = this.valuesDictionary["cote-c"];
                    const a = this.valuesDictionary["cote-a"];
                    const e = this.valuesDictionary["cote-e"];
                    if (c !== (a - e)) {
                        this.errorsDictionary["cote-c"] = ruleName;
                    } else {
                        delete this.errorsDictionary["cote-c"];
                    }
                }

                break;
            }*/
            /*case "4-pans-l-3-pignons": {

                // A = D + E
                ruleName = "a-eq-d-plus-e-";
                if (
                    this.valuesDictionary["cote-a"] !== undefined
                    && this.valuesDictionary["cote-d"] !== undefined
                    && this.valuesDictionary["cote-e"] !== undefined
                ) {
                    console.log(RoofDimensionsComponent.TAG, "Checking rule " + ruleName + " ...");
                    const a = this.valuesDictionary["cote-a"];
                    const d = this.valuesDictionary["cote-d"];
                    const e = this.valuesDictionary["cote-e"];
                    if (a !== (d + e)) {
                        this.errorsDictionary["cote-a"] = ruleName;
                    } else {
                        delete this.errorsDictionary["cote-a"];
                    }
                }

                break;
            }*/
            /*case "4-pans-t": {

                // A = D + E + F
                ruleName = "a-eq-d-plus-e-plus-f";
                if (
                    this.valuesDictionary["cote-a"] !== undefined
                    && this.valuesDictionary["cote-d"] !== undefined
                    && this.valuesDictionary["cote-e"] !== undefined
                    && this.valuesDictionary["cote-f"] !== undefined
                ) {
                    console.log(RoofDimensionsComponent.TAG, "Checking rule " + ruleName + " ...");
                    const a = this.valuesDictionary["cote-a"];
                    const d = this.valuesDictionary["cote-d"];
                    const e = this.valuesDictionary["cote-e"];
                    const f = this.valuesDictionary["cote-f"];
                    if (a !== (d + e + f)) {
                        this.errorsDictionary["cote-a"] = ruleName;
                    } else {
                        delete this.errorsDictionary["cote-a"];
                    }
                }

                break;
            }*/
            case "6-pans-v":
            case "4-pans-v": {

                // A > E
                ruleName = "a-sup-e";
                if (
                    this.valuesDictionary["cote-a"] !== undefined
                    && this.valuesDictionary["cote-e"] !== undefined
                ) {
                    console.log(RoofDimensionsComponent.TAG, "Checking rule " + ruleName + " ...");
                    const a = this.valuesDictionary["cote-a"];
                    const e = this.valuesDictionary["cote-e"];
                    if (a < e) {
                        this.errorsDictionary["cote-a"] = ruleName;
                    } else {
                        delete this.errorsDictionary["cote-a"];
                    }
                }

                // B > D
                ruleName = "b-sup-d";
                if (
                    this.valuesDictionary["cote-b"] !== undefined
                    && this.valuesDictionary["cote-d"] !== undefined
                ) {
                    console.log(RoofDimensionsComponent.TAG, "Checking rule " + ruleName + " ...");
                    const b = this.valuesDictionary["cote-b"];
                    const d = this.valuesDictionary["cote-d"];
                    if (b < d) {
                        this.errorsDictionary["cote-b"] = ruleName;
                    } else {
                        delete this.errorsDictionary["cote-b"];
                    }
                }

                break;
            }
            // case "2-pans-decrochage":
            /*case "6-pans-l": {

                // A = C + D
                ruleName = "a-eq-c-plus-d";
                if (
                    this.valuesDictionary["cote-a"] !== undefined
                    && this.valuesDictionary["cote-c"] !== undefined
                    && this.valuesDictionary["cote-d"] !== undefined
                ) {
                    console.log(RoofDimensionsComponent.TAG, "Checking rule " + ruleName + " ...");
                    const a = this.valuesDictionary["cote-a"];
                    const c = this.valuesDictionary["cote-c"];
                    const d = this.valuesDictionary["cote-d"];
                    if (a !== (c + d)) {
                        this.errorsDictionary["cote-a"] = ruleName;
                    } else {
                        delete this.errorsDictionary["cote-a"];
                    }
                }

                // B = E + F
                ruleName = "b-eq-e-plus-f";
                if (
                    this.valuesDictionary["cote-b"] !== undefined
                    && this.valuesDictionary["cote-e"] !== undefined
                    && this.valuesDictionary["cote-f"] !== undefined
                ) {
                    console.log(RoofDimensionsComponent.TAG, "Checking rule " + ruleName + " ...");
                    const b = this.valuesDictionary["cote-b"];
                    const e = this.valuesDictionary["cote-e"];
                    const f = this.valuesDictionary["cote-f"];
                    if (b !== (e + f)) {
                        this.errorsDictionary["cote-b"] = ruleName;
                    } else {
                        delete this.errorsDictionary["cote-b"];
                    }
                }

                break;
            }*/
            default: {
                break;
            }
        }

    }

    /**
     * Check minimum and maximum value of a dictionary key. If validation fail the error message is
     * saved in the errors dictionary
     *
     * @param {string} pId
     * @param {number} min
     * @param {string} minKey
     * @param {number} max
     * @param {string} maxKey
     */
    private checkMinMax(pId: string, min: number, minKey: string, max: number, maxKey: string): void {

        // TODO : Remove / Debug Edge / #29133
        // ------------------------
        Object.keys(this.roofingDimensionsForm.form.controls).map((field) => {
            if (field === pId) {
                const control = this.roofingDimensionsForm.form.get(field);
                if (control instanceof FormControl) {
                    console.log("DEBUG / #29133", pId, control.value, (<any> document.getElementById(pId)).value);
                }
            }
        });
        // ------------------------

        // Max
        if (this.valuesDictionary[pId] > max) {
            this.errorsDictionary[pId] = maxKey;
            Utils.markAsDirty(this.roofingDimensionsForm, pId);
        }
        // Min
        if (this.valuesDictionary[pId] < min) {
            this.errorsDictionary[pId] = minKey;
            Utils.markAsDirty(this.roofingDimensionsForm, pId);
        }

    }

    /**
     * Get current roof-type and surelevation field values.
     *
     * @param pId
     */
    private getFields(pId: string): void {

        console.log(RoofDimensionsComponent.TAG, "getFields()", pId);

        const confData: ConfDataType = this.confDataService.confdata[pId];

        if (!confData || !confData.values || confData.values.length === 0) {
            this.dimensionsType = undefined;
            return;
        }

        console.log(RoofDimensionsComponent.TAG, "[AppService] getType()", AppService.ROOF_DIMENSIONS_URL, confData.values[0]);

        this.appService.getType(AppService.ROOF_DIMENSIONS_URL, confData.values[0])
            .then(type => {
                this.dimensionsType = type;

                console.log(RoofDimensionsComponent.TAG, "dimensionsType", this.dimensionsType);

                // Set default value for dimension
                for(let dim of this.dimensionsType.values[0].values) {
                    if(dim.options[0].default != undefined) {
                        this.valuesDictionary[dim.id] = dim.options[0].default;
                    }
                }

                // Set default value for detail
                for(let detail of this.dimensionsType.values[1].values) {
                    if(detail.options[0].default != undefined) {
                        this.valuesDictionary[detail.id] = detail.options[0].default;
                    }
                }
            })
            .catch(this.handleError.bind(this));

        const dimensionsData: any[] = this.confDataService.getElementValues("roof-dimensions");

        // Reset values to empty input fields before updating dictionary.
        if (this.valuesDictionary) {
            for (const key in this.valuesDictionary) {
                if (this.valuesDictionary.hasOwnProperty(key)) {
                    this.valuesDictionary[key] = NaN;
                }
            }
        }

        this.valuesDictionary = dimensionsData && dimensionsData.length > 0 ? dimensionsData[0] : {};
        this.errorsDictionary = {};
    }

    private handleError(error: any): void {
        console.error(RoofDimensionsComponent.TAG, "An error occurred", error);
    }

    public getData(): void {
        super.getData();
        this.appService.getData(AppService.ROOF_DIMENSIONS_URL).then(types => this.types = types);
        if (this.confDataService.getElementOptions("project-type") !== undefined) {
            this.selectedFacadeOption = this.confDataService.getElementOptions("project-type").find(typeId => typeId.indexOf("facade") !== -1);
            this.belrivTradiSelected = (this.confDataService.getElementOptions("project-type") && this.confDataService.getElementOptions("project-type").indexOf("belriv-tradi") != -1)
        }
        this.roofType = this.confDataService.getElementValues("roof-type")[0];
        console.log(RoofDimensionsComponent.TAG, "roof-type", this.roofType);

    }

    protected onSubmit(e: NgForm): void {
        console.log(RoofDimensionsComponent.TAG, "onSubmit()");
        if (this.checkValid(e)) {
            this.onClickValidate(null);
        }
    }

    private checkValid(e: NgForm): boolean {

        console.log(RoofDimensionsComponent.TAG, "checkValid()", e);

        // Check constraint operations
        this.checkCoteConstraints();

        Utils.checkFormControlsValidity(e.form);

        // Form is valid and no error detected on "cotes"
        if (e.valid && Object.keys(this.errorsDictionary).length === 0) {
            this.confDataService.updateElementValues("roof-dimensions-valid", ["true"]);
            return true;
        } else {
            this.confDataService.updateElementValues("roof-dimensions-valid", ["false"]);
            return false;
        }

    }

    public ngOnInit(): void {
        super.ngOnInit();

        this.appService.getInputFieldMessagesTypes()
            .then(types => this.inputFieldMessages = types);

        this.confDataService.observable.subscribe(
            (value) => {
                if (value.id === "roof-type") {
                    this.getFields("roof-type");
                }
                if (value.id === "project-type") {
                    if (value.options !== undefined) {
                        this.selectedFacadeOption = value.options.find(typeId => typeId.indexOf("facade") !== -1);
                    }else{
                        this.selectedFacadeOption = undefined;
                    }
                }
            }
        );

        // Force values update
        this.getFields("roof-type");
    }
}



// WEBPACK FOOTER //
// ./src/app/main-view/roof-dimensions/roof-dimensions.component.ts